import { useQuery } from "@apollo/client/react"; import { Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';

import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';
import { IndicacionInput } from './IndicacionInput';
import toast from 'react-hot-toast';

export const StepProgramaAE2 = ({
  setDataSubmissionCallback,
  pantallas,
  updateFormData,
  fullFormDataRI,
  idDatosGeneralesRI,
  programasSeleccionadosAbrev,
  edit
}) => {

  const [datosProgramaAE, setDatosProgramaAE] = useState(fullFormDataRI?.programaAE2 ?? {});
  const [childrenAction, setChildrenAction] = useState(null);
  const [combosRI, setCombosRI] = useState();
  const [tieneIndicaciones, setTieneIndicaciones] = useState(false);

  const idPantallaRI = useMemo(() => {
    return pantallas.find((p) => p.displayName.includes('AE'))?.id;
  }, [pantallas]);


  const inputCombos = inputsGroups.flatMap((inputgroup) => {
    return inputgroup.inputs.filter((input) => !!input.comboName);
  });

  const handleSubmit = () => {
    if (!tieneIndicaciones && !programasSeleccionadosAbrev.includes('SSAE')) {
      return toast.error('Agregar al menos una indicación.');
    }
    updateFormData('programaAE2', datosProgramaAE, parsedInputsGroup.flatMap((x) => x.inputs).filter((x) => !x.nonValidate));
  };

  const { data: combosData } = useQuery(getStringQueryCombosRI(inputCombos));

  useEffect(() => {
    if (!combosData) return;

    setCombosRI(adaptCombosRIArray(combosData));
  }, [combosData]);

  const handleChange = (name, value) => {
    setDatosProgramaAE((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const parsedInputsGroup = useMemo(() => {

    if (!combosRI) return inputsGroups;

    return structuredClone(inputsGroups).map((group) => ({
      ...group,
      inputs: group.inputs.map((input) => {
        if (!!input.comboName) {
          input.options = combosRI[input.name];
        }

        if (input.name === 'idComboRIValorModoInfusionAE' && !!programasSeleccionadosAbrev.includes('SSAE')) {
          input.required = false;
        }

        return input;
      })
    }));
  }, [combosRI]);

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [datosProgramaAE, setDataSubmissionCallback, parsedInputsGroup, tieneIndicaciones]);

  return (
    <div>
      {parsedInputsGroup.map((group) =>
        <div className='step-form-section-container' key={group.groupName}>
          <label className={`step-form-section-title ${childrenAction ? 'with-children-action' : ''}`}>
            {group.groupName}
            {Boolean(childrenAction) && childrenAction}
          </label>
          <Grid container>
            {group.inputs.map((input) => {
              return (
                <>
                  {input.name !== 'indicaciones' && <RenderInputByTypeMobile
                    key={`${group.groupName}-${input.name}`}
                    grided
                    handleChange={handleChange}
                    input={input}
                    value={datosProgramaAE[input.name]} />
                  }
                  {input.name === 'indicaciones' && <IndicacionInput
                    idDatosGeneralesRI={idDatosGeneralesRI}
                    setTieneIndicaciones={setTieneIndicaciones}
                    idPantallaRI={idPantallaRI}
                    setChildrenAction={setChildrenAction}
                    edit={edit} />
                  }
                </>);

            })}
          </Grid>
        </div>
      )}
    </div>);

};

const inputsGroups = [
  {
    groupName: 'Indicaciones',
    inputs: [
      {
        name: 'indicaciones',
        displayName: 'Indicación',
        nonValidate: true
      },
      {
        name: 'idComboRIValorModoInfusionAE',
        displayName: 'Modo de infusión',
        comboName: 'Modo de infusión NE',
        type: 'select',
        required: true
      },
      {
        name: 'llevaBomba',
        displayName: 'Lleva bomba',
        type: 'custom_switch',
        required: true
      }]

  }];